import { createTheme } from "@mui/material"
import { blue, green, grey, orange, red } from "@mui/material/colors"
import { colorsDeclinations, commonTheme } from "./common"

export const lightTheme = createTheme(commonTheme, {
	palette: {
		mode: "light",
		tonalOffset: 0.2,
		primary: {
			main: blue[500],
			contrastText: "#fff",
		},
		secondary: {
			main: grey[600],
		},
		error: {
			main: red[500],
		},
		warning: {
			main: orange[800],
		},
		success: {
			main: "#34D399",
			contrastText: "#fff",
		},
		green,
		grey,
		...colorsDeclinations(["red", "blue", "yellow"]),
	},
	shape: {
		borderRadius: 4,
	},
})
